module.exports = __webpack_public_path__ + "static/screen-classic-laptop@2x-79a8156d95a301c785a9be6b17f53622.webp";